import popupStyles from "./appointmentOpenedPopup.module.css";
import doctor from "../../../images/questionnaire_doctor.png";
import { IPopupWithoutProps } from "../../../types/types";
import CloseButton from "../../closeButton/closeButton";


function AppointmentOpenedPopup({
    onClose,
}: IPopupWithoutProps) {
    return (
        <article className={popupStyles.popup}>
            <CloseButton onClick={onClose} />
            <h2 className={popupStyles.popup__title}>פנייתך נשלחה בהצלחה</h2>
            <p className={popupStyles.popup__text}>
                הודעת SMS תישלח אליך ברגע בו פנייתך תיאסף על ידי מטפל
            </p>
            <img
                src={doctor}
                alt="תמונה של וונצ’י"
                className={popupStyles.popup__img}
            />
            <p className={popupStyles.popup__text}>
                הינך מועבר לדף הבית            </p>
            <button
                className={`button hover ${popupStyles.popup__nextBtn}`}
                onClick={onClose}
            >
                אישור            </button>
        </article>
    );
}

export default AppointmentOpenedPopup;
